<template>
  <div class="passport-container">
    <div class="logo-container">
      <div class="logo">
        <a href="/">
          <img src="../../assets/images/logo.png" height="32px" width="125px" />
        </a>
      </div>
    </div>
    <div class="passport">
      <h1>注册</h1>
      <p class="sm-tip treaty">
        注册即表示您同意
        <a class="em" href="/user-agreement" target="_blank">服务协议</a>与
        <a class="em" href="/private-agreement" target="_blank">隐私协议</a>
      </p>
      <div class="error-tip-container">
        <p class="error-tip mini red-txt lighter-red-bg text-center" v-if="errorText">{{errorText}}</p>
      </div>
      <form autocomplete="off">
        <YueDanIpt
          class="username"
          model="username"
          :object="register"
          :focus="true"
          placeholder="用户名"
        ></YueDanIpt>
        <div style="margin-bottom:10px;">
          <div style="width:28%;display:inline-block;vertical-align: middle;" class="areaCode">
            <el-select v-model="register.mobile_country_code" placeholder="区号">
              <el-option
                v-for="(item,index) in reorder"
                :key="index"
                :label="'+'+item.key"
                :value="item.key"
              >
                <span>
                  <div>{{item.value}}</div>
                </span>
              </el-option>
            </el-select>
          </div>
          <div style="width:70%;display:inline-block;vertical-align: middle;">
            <YueDanIpt
              model="mobile"
              :object="register"
              placeholder="手机号"
              v-on:areaSelect="areaSelect"
            ></YueDanIpt>
          </div>
        </div>
        <YueDanIpt model="verify_code" type="password" :object="register" placeholder="验证码">
          <a v-if="!seconds" class="get-password" style="cursor:pointer;" @click="getCode()">获取验证码</a>
          <a v-if="seconds" class="get-password">{{seconds}} s</a>
        </YueDanIpt>
        <YueDanIpt class="username" model="email" :object="register" placeholder="邮箱"></YueDanIpt>
        <YueDanIpt model="password" type="password" :object="register" placeholder="密码"></YueDanIpt>
        <div class="btn-container">
          <el-button type="primary block" @click="submit()" :loading="loading">注&nbsp;册</el-button>
        </div>
        <div class="footer-container">
          <a class="normal-content" href="/login">已拥有账户，去登录</a>
          <a class="dialog-content" @click="showLoginDialog()">已拥有账户，去登录</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import api from '../../services/api.js'
import YueDanIpt from '../../components/YueDanIpt'
import { areaCode } from '../../services/constant.js'
let $ = require('jQuery')

export default {
  name: 'Register',
  props: ['isDialog'],
  components: {
    YueDanIpt: YueDanIpt
  },
  data () {
    return {
      seconds: null,
      areaCode: areaCode,
      register: {
        username: '',
        email: '',
        password: '',
        mobile: '',
        mobile_country_code: '86',
        verify_code: ''
      },
      isEmptyErrors: true,
      loading: false,
      errorText: '',
      open_id: null
    }
  },
  computed: {
    reorder: function () {
      return this.areaCode.sort(function (x, y) {
        return x['value'].localeCompare(y['value'])
      })
    }
  },
  created () {
    this.open_id = localStorage.getItem('openid')
  },
  methods: {
    getCode () {
      this.errorText = ''
      if (!this.register.mobile) {
        this.errorText = '手机号是必填项'
        return
      } 
      switch(this.register.mobile_country_code){
        case "86":
          if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.register.mobile)) {
            this.errorText = '请输入有效的手机号码'
            return
          }
          else 
            break;
        case "81":
          if (!/\d{10}/.test(this.register.mobile)) {
            this.errorText = '请输入有效的手机号码'
            return
          }
          else
            break;
        default:
          break;
      }
      api.post(this, {
          path: 'passport_v2.php',
          api: 'register_send_sms',
          data: {
            mobile: this.register.mobile,
            mobile_country_code: this.register.mobile_country_code
          }
        })
        .then(
          res => {
            if (res.body.result == 'send_after_two_minutes') {
              this.errorText = '操作频繁，请稍后再试'
              return
            }
            if (res.body.result == 'mobile_exist') {
              this.errorText = '该手机已注册,请更换其他手机'
              return
            }
            this.seconds = 60
            let timer = setInterval(() => {
              this.seconds--
              if (this.seconds == 0) {
                clearInterval(timer)
              }
            }, 1000)
          },
          err => {
            this.loading = false
          }
        )
    },
    areaSelect (data) {
      this.register.mobile_country_code = data
    },
    submit: function () {
      this.isEmptyErrors = true
      _.each(
        ['test', 'admin', 'administrator', 'guest', 'joy', 'order'],
        item => {
          if (this.register.username.indexOf(item) > -1) {
            this.isEmptyErrors = false
            this.errorText = '用户名不能包含‘' + item + '’'

            return false
          }
        }
      )
      let str = this.register.username.match(/[^\x00-\xff]/gi)
      if (str) {
        let length = this.register.username.length + str.length * 2
        if (length < 6) {
          this.isEmptyErrors = false
          this.errorText = '用户名不能低于6个字符'
          return
        }
        if (length > 12) {
          this.isEmptyErrors = false
          this.errorText = '用户名不能超过12个字符'
          return
        }
      } else {
        if (this.register.username.length < 6) {
          this.isEmptyErrors = false
          this.errorText = '用户名不能低于6个字符'
          return
        }
      }
      if (!this.register.username) {
        this.isEmptyErrors = false
        this.errorText = '用户名是必填项'
        return
      }
      switch(this.register.mobile_country_code){
        case "86":
          if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.register.mobile)) {
            this.isEmptyErrors = false
            this.errorText = '请输入有效的手机号码'
            return
          }
          else 
            break;
        case "81":
          console.log('mob',this.register.mobile)
          if (!/^\d{10}$/.test(this.register.mobile)) {
            this.isEmptyErrors = false
            this.errorText = '请输入有效的手机号码'
            return
          }
          else
            break;
        default:
          break;
      }
      if (!this.register.verify_code) {
        this.isEmptyErrors = false
        this.errorText = '请输入短信验证码'
        return
      }
      if (!this.isEmptyErrors) {
        return
      }
      let res,
        err = this.validation()
      if (err) {
        this.errorText = err
        return false
      }
      this.errorText = ''
      api
        .post(this, {
          path: 'passport_v2.php',
          api: 'register',
          data: this.register,
          loading: 'loading'
        })
        .then(
          res => {
            switch (res.data.result) {
              case 'success':
                this.errorText = ''
                this.login()
                break
              case 'username_exist':
                this.errorText = '用户名已存在'
                break
              case 'email_exist':
                this.errorText =
                  '此邮箱已被注册，请使用此邮箱去登录或尝试新邮箱'
                break
              case 'need_email':
                this.errorText = '邮箱是必填项'
                break
              case 'need_password':
                this.errorText =
                  '密码长度为8~30位，必须同时包含大小写字母,数字'
                break
              case 'mobile_exist':
                this.errorText = '该手机已注册,请更换其他手机号码'
                break
              case 'wrong_verify_code':
                this.errorText = '手机验证码不正确'
                break
              case 'verify_code_expired':
                this.errorText = '手机验证码已过期,请重新获取'
                break
            }
          },
          err => {}
        )
    },
    validation: function () {
      if (!$.trim(this.register.username)) {
        return null, '用户名是必填项'
      }
      if (/^[0-9]*$/.test(this.register.username.substring(0, 1))) {
        return null, '用户名不能以数字开头'
      }
      if (this.register.username.indexOf('@') > -1) {
        return null, '用户名不能有@'
      }
      if (this.register.username.length > 12) {
        return null, '用户名不能超过12个字符'
      }
      if (
        !/^(?!\d+$)[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(this.register.username)
      ) {
        return null, '用户名不能为纯数字,不能包含空格,不能包含特殊字符'
      }
      if (!$.trim(this.register.mobile)) {
        return null, '手机号是必填项'
      }
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.register.mobile)) {
        return null, '请输入正确的手机号'
      }
      // if (!$.trim(this.register.email)) {
      //   return null, '邮箱是必填项'
      // }
      if (
        this.register.email &&
        !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
          this.register.email
        )
      ) {
        return null, '你必须输入有效电子邮件地址'
      }
      // let reg = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$')
      if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,30}$/.test(
          this.register.password
        )
      ) {
        return null, '密码长度为8~30位，必须同时包含大小写字母,数字'
      }
    },
    login: function () {
      api
        .post(this, {
          path: 'passport.php',
          api: 'login',
          data: {
            username: this.register.username,
            password: this.register.password
          },
          loading: 'loading'
        })
        .then(
          res => {
            let data = res.data
            if (data.status === 'ok') {
              this.$localStorage.set('token', data.result)
              this.$localStorage.set('login_type', data.description)
              if (this.open_id) {
                this.bind()
              }
              setTimeout(() => {
                if (this.isDialog) {
                  this.$emit('success')
                  location.reload()
                } else {
                  this.$router.push({ path: '/' })
                }
              }, 1000)
              return false
            }
            switch (data.result) {
              case 'wrong_password':
                this.errorText = '密码错误'
                break
              case 'need_username':
                this.errorText = '用户名是必填项'
                break
              case 'need_password':
                this.errorText = '密码是必填项'
                break
            }
          },
          err => {}
        )
    },
    bind () {
      let url = 'https://wechat.joyorders.com/api.php?api=bind_user'
      this.$http
        .post(url, {
          open_id: this.open_id,
          username: this.register.email,
          password: this.register.password
        })
        .then(data => {
          if (
            data.body.result === 'success' ||
            data.body.result === 'already_bind'
          ) {
            this.$localStorage.set('username', this.register.username)
          }
        })
    },
    showLoginDialog () {
      this.$store.commit('showGlobalDialog', 'loginVisible')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.treaty {
  font-size: 13px;
  width: 280px;
}
.em {
  /*font-weight: bold;*/
  text-decoration:underline;
}
</style>



// WEBPACK FOOTER //
// src/pages/passport/Register.vue